import React from "react";
import {Tooltip} from "@material-ui/core";

export default function EllipsisCell({ value }) {
    const textRef = React.useRef(null)
    const [isTruncated, setIsTruncated] = React.useState(false)

    const checkTruncation = () => {
        const element = textRef.current
        setIsTruncated(!!element && element.scrollWidth > element.clientWidth)
    }

    return <Tooltip title={isTruncated ? value : ""}>
        <span
            ref={textRef}
            onMouseEnter={checkTruncation}
            style={{width: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}
        >
            {value}
        </span>
    </Tooltip>
}
